/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  SET_LOADING_SPINNER = '[Shared] set loading spinner',

  GET_DASHBOARD_WIDGETS = '[Shared] Get Dashboard Widgets',
  GET_DASHBOARD_WIDGETS_SUCCESS = '[Shared] Get Dashboard Widgets Success',
  GET_DASHBOARD_WIDGETS_FAILED = '[Shared] Get Dashboard Widgets Failed',

  SELECT_ROOM = '[Campus] Select Room',
  SELECT_SUBJECT = '[Campus] Select Subject',
  SELECT_PROFESSOR = '[Campus] Select Professor',
}

export const setLoadingSpinner = createAction(
  ActionTypes.SET_LOADING_SPINNER,
  props<{ status: boolean }>()
);

export const getDashboardWidgets = createAction(
  ActionTypes.GET_DASHBOARD_WIDGETS,
  props<{ data: any }>()
);

export const getDashboardWidgetsSuccess = createAction(
  ActionTypes.GET_DASHBOARD_WIDGETS_SUCCESS,
  props<{ data: any }>()
);

export const getDashboardWidgetsFailed = createAction(
  ActionTypes.GET_DASHBOARD_WIDGETS_FAILED,
  props<{ data: any }>()
);

export const selectRoom = createAction(
  ActionTypes.SELECT_ROOM,
  props<{ data: any }>()
);

export const selectSubject = createAction(
  ActionTypes.SELECT_SUBJECT,
  props<{ data: any }>()
);

export const selectProfessor = createAction(
  ActionTypes.SELECT_PROFESSOR,
  props<{ data: any }>()
);